module.exports = __webpack_public_path__ + "assets/images/amountofPlants-01.0b504e939a29cc9bf5e872599876a13f.svg";